export default "__VITE_ASSET__Buzo_9QH__"